import * as Modification from '@/services/legal-ad-form/components/modification';
import * as Company from '@/services/legal-ad-form/components/modification/company';
import * as Decision from '@/services/legal-ad-form/components/modification/decision';
import * as HeadOffice from '@/services/legal-ad-form/components/modification/head-office';
import * as Mention from '@/services/legal-ad-form/components/modification/mention';
import { trimObject } from '@/shared/utils';

export default {
  id: 'duree',
  label: 'Durée (prorogation)',
  shortLabel: 'Durée (prorogation)',
  componentsData: {
    company: { legalForm: '' },
    headOffice: {},
    decision: { type: '', actor: '' },
    modification: {},
    mention: { registry: 'Mention sera portée au RCS de ...(à compléter)' }
  },
  component: () => import('@/components/legal-ads/forms/models/modification/duration.vue'),
  validate(modelData) {
    return trimObject({
      company: Company.validate(modelData.company),
      headOffice: HeadOffice.validate(modelData.headOffice),
      decision: Decision.validate(modelData.decision),
      modification: Modification.validateDuration(modelData.modification),
      mention: Mention.validate(modelData.mention)
    });
  },
  buildContent(modelData) {
    return [
      Company.buildContent(modelData.company, { withShareCapital: true }),
      HeadOffice.buildContent(modelData.headOffice),
      Modification.buildDurationContent(modelData),
      Mention.buildContent(modelData.mention)
    ].flat().join("\n").replace(/undefined/g, '?');
  }
};
